<template>
    <div
        class="cubeBox_item"
        v-bind:class="{
            active: isActive,
        }"
        v-on:click="emit('click')"
    >
        <slot>
            <SboIcon
                v-if="icon?.type === 'sboIcon'"
                v-bind:name="icon.name"
                v-bind:style="{ color: 'initial' }"
                size="xxl"
            />
            <SvgIcon
                v-else-if="icon?.type === 'svg'"
                size="xxl"
                v-bind:name="icon.name"
            />
        </slot>
    </div>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import type { ISportListIcon } from '@/interface/ISport';

    defineProps({
        icon: {
            type: Object as PropType<ISportListIcon>,
            default: undefined,
        },
        isActive: {
            type: Boolean,
            required: true,
        },
    });

    const emit = defineEmits(['click']);
</script>
